export default {
  components: {
    locationSelector: {
      labelKey: 'cmp-bus-directory-map-sub-title-key-location',
      inputItem: {
        placeholder: 'cmp-bus-directory-map-select-bus-station',
      },
    },
    list: {
      itemSettings: {
        open: true,
        departureArriveInfoStyles: {
          showStationLink: false,
        },
      },
    },
  },
  prePopulation: {
    locationSearchOptions: {
      outputCategory: ['STATIONS'],
    },
  },
};
